import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_selectionStart(_this__u8e3s4) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.selectionStart;
}
function get_selectionEnd(_this__u8e3s4) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.selectionEnd;
}
function setSelectionRange(_this__u8e3s4, start, end) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.setSelectionRange(start, end);
  }
}
function usingWebOnMobile() {
  return contains(window.navigator.userAgent, 'Mobi');
}
//region block: exports
export {
  get_selectionEnd as get_selectionEnd3mrxxhylrrnmx,
  get_selectionStart as get_selectionStart3uifq0rid3t9y,
  setSelectionRange as setSelectionRangez4trgvl3f63c,
  usingWebOnMobile as usingWebOnMobile1whyqijwjkjd1,
};
//endregion

//# sourceMappingURL=NumberField.commonHtml.js.mjs.map
